import * as yup from 'yup';

export const businessRegistrationSchema = yup.object().shape({
  business_name: yup.string().required('Business name is required'),
  business_type_id: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .required('Business type is required')
    .typeError('Please select a business type'),
  business_nature_id: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .required('Nature of business is required')
    .typeError('Please select a nature of business'),
  name: yup
    .string()
    .when('is_resident', {
      is: 'false',
      then: (schema) => schema.required('Owner is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  owner_id: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value))
    .when('is_resident', {
      is: 'true',
      then: (schema) => schema.required('Owner is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  classification: yup.string().required('Classification is required'),
  is_resident: yup.string().required('Resident status is required'),
  region: yup.string().required('Region is required'),
  barangay: yup.string().required('Barangay is required'),
  municipality: yup.string().required('Municipality is required'),
  province: yup.string().required('Province is required'),
  street_name: yup.string().required('Street name is required'),
  purok_zone: yup.string().required('Purok is required'),
  zip_code: yup.string().required('ZIP code is required'),
});

export const businessTypeSchema = yup.object().shape({
  name: yup.string().required('Business type name is required'),
  description: yup.string().required('Short description is required'),
});

export const natureOfBusinessSchema = yup.object().shape({
  name: yup.string().required('Nature of business name is required'),
  description: yup.string().required('Short description is required'),
});

